export const ACCOUNT_REFRESH_EVENT =
  'kraken:account-refresh'

export function requestAccountRefresh(): void {
  window.dispatchEvent(
    new CustomEvent(
      ACCOUNT_REFRESH_EVENT,
    ),
  )
}
